import React from 'react';

/* Translations */
import { useTranslation } from 'react-i18next';

/* Dependencies */
import * as Yup from 'yup';

/* Styled Components */
import {
  StylesPermissionsStepWraper,
  Content,
  Label,
  InputGroup,
  ContentTitle,
  ContentSubtitle,
  WrapperSelecter,
} from '../styles';

/* Components */
import { Form, Formik } from 'formik';

/* Hooks, Services */
import RenderIf from 'components/RenderIf';
import { Selecter } from 'lego-dist';
import useCenters from 'hooks/centers/UseCenters';
import { useRouter } from 'routes';

export interface CenterStepProps {
  nextStep?: any;
  renderFooter?: any;
  formData?: any;
}

const CenterStep: React.FC<CenterStepProps> = ({ renderFooter, formData }) => {
  const { t } = useTranslation();
  const { centers = [] } = formData;
  /* get center id */
  const {
    currentParamsRef: {
      current: { centerId },
    },
  } = useRouter();
  const initialValues = {
    centers: centers?.length ? centers : [Number(centerId)],
  };

  const { centerList } = useCenters();

  /* Validation */
  const CenterForm = Yup.object().shape({
    centers: Yup.array(),
  });

  const buildCenterList = () => {
    return centerList?.map((center: any) => ({
      ...center,
      label: center.name,
      value: center.id,
    }));
  };

  return (
    <StylesPermissionsStepWraper>
      <Formik
        initialValues={initialValues}
        validationSchema={CenterForm}
        onSubmit={() => {}}
        validateOnBlur
        isInitialValid={initialValues?.centers?.length}
        validateOnChange
        render={({ setFieldValue, values, isValid }) => (
          <Form>
            <Content>
              <ContentTitle>
                {t(
                  'settings:STAFF_SECTION.MANAGE.ADD_MEMBER_VIEW.STEPS.GENERAL_INFO.ASSIGN_CENTERS',
                )}
              </ContentTitle>
              <ContentSubtitle>
                {t(
                  'settings:STAFF_SECTION.MANAGE.ADD_MEMBER_VIEW.STEPS.GENERAL_INFO.ASSIGN_CENTERS_SUBTITLE',
                )}
              </ContentSubtitle>
              <InputGroup>
                <Label>
                  {t('settings:CENTER_SECTION:CENTER')}
                </Label>
                <WrapperSelecter>
                  <Selecter
                    data={buildCenterList()}
                    name="centers"
                    value={values.centers}
                    onChange={(newValue: any) => {
                      setFieldValue('centers', newValue);
                    }}
                    placeholder={t('calendar_events:SELECT_OPTION')}
                    multiple
                    checkbox
                    search
                  />
                </WrapperSelecter>
              </InputGroup>
            </Content>
            <RenderIf condition={renderFooter}>
              {renderFooter(isValid , { center: values })}
            </RenderIf>
          </Form>
        )}
      />
    </StylesPermissionsStepWraper>
  );
};

export default CenterStep;
